import { useKeydownHandler } from 'owa-hotkeys';

export function useAllowNativeUndo<TElement extends HTMLElement>(
    textArea: React.RefObject<TElement>
) {
    useKeydownHandler(
        textArea,
        'ctrl+z',
        () => {
            // do nothing -- this keydown handler stops propagation so that the mailmodule
            // does not eat the undo action & the browser's native Undo functionality can work.
        },
        {
            preventDefault: false,
            allowHotkeyOnTextFields: true,
        }
    );
}
